<template>
  <b-container class="communes">
    <h1 class="titre">Prochains passages<br/>{{ this.$route.params.idZone }}</h1>
    <h2 class="selection_arret">Sélectionnez la ligne de votre choix :</h2>
    <div class="div_loader" v-if="loading">
      <b-spinner class="loader" type="grow" label="Spinning"></b-spinner>
    </div>
    <div class="liste_lignes">
      <div v-for="ligne in lignes" :key="ligne.route_id" class="ligne-item">
        <b-btn
          :to="{name: 'Arrets', params: {routeId: ligne.route_id}}"
          class="arret col-12"
          :style="{ borderColor: adjustColor(ligne.route_color), backgroundColor: '#'+ ligne.route_color }"
        >
          <div class="route-info w-100 d-flex flex-column flex-md-row align-items-center">
            <span class="nom_arret short_name col-12 col-md-2 text-center">{{ ligne.route_short_name }}</span>
            <span class="nom_arret long_name col-12 col-md-10 text-center">{{ ligne.route_long_name }}</span>
          </div>
        </b-btn>
      </div>
    </div>
  </b-container>
</template>

<script>
import axios from 'axios'
import router from '../router'
import {colors} from "nightwatch/lib/util/logger";

export default {
  name: 'Lignes',
  data () {
    return {
      lignes: null,
      loading: false
    }
  },
  methods: {
    colors,
    goToProchainPassageSiUnSeulArret: function () {
      if (this.lignes.length === 1) {
        router.replace('route' + this.lignes[0])
      }
    },
    adjustColor(color) {

      return '#'+ color ;
    }
  },
  mounted () {
    this.loading = true
    axios.get('/gtfs/routes')
      .then((succes) => {
        this.lignes = succes.data
        console.log(succes.data)
        this.loading = false
        this.goToProchainPassageSiUnSeulArret()
      }, (error) => {
        console.error('ERREUR', error.body)
        this.loading = false
      })
  }
}
</script>

<style lang="scss">
@import "../sass/variables";
@import "../../node_modules/bootstrap/scss/bootstrap";

.communes {
  text-align: center;
  margin-top: 3rem;

  .titre {
    color: $secondcolor;
    font-family: $titlefont;
    font-size: 40px;
    font-weight: bold;
    margin-bottom: 2rem;
  }

  .selection_arret {
    color: $firstcolor;
    font-family: $textfont;
    font-size: 30px;
  }

  .div_loader {
    display: flex;
    margin: 4rem 0;
    @include media-breakpoint-up(sm) {
      height: 0;
    }

    .loader {
      margin: auto;
      color: $secondcolor;
      width: 6rem;
      height: 6rem;
    }
  }

  .liste_lignes {
    margin-top: 2rem;

    .ligne-item {
      margin-bottom: 15px;

      .arret {
        width: 100%;
        border: 2px solid;
        color: black;
        border-radius: 10px;
        font-family: $titlefont;
        font-size: 20px;
        padding: 1rem;
        text-decoration: none;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        transition: background-color 0.3s, color 0.3s;

        .nom_arret {
          margin: 5px 0;
        }
      }

      .arret:hover {
        color: whitesmoke;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Lignes.vue